import { BaseService, Service } from "/@/cool";
import type { UploadInvoiceParams } from "/$/commission/types/orderCommission";

@Service("orderCommissionInvoice")
class OrderCommissionInvoiceService extends BaseService {
	constructor() {
		super();
		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}
		this.permission["page"] = prefix + "page";
		this.permission["upload"] = prefix + "upload";
		this.permission["detail"] = prefix + "detail";
	}

	detail(data: { id: number }) {
		return this.request({
			url: "/detail",
			method: "POST",
			data
		});
	}

	upload(data: UploadInvoiceParams) {
		return this.request({
			url: "/upload",
			method: "POST",
			data
		});
	}
}

export default OrderCommissionInvoiceService;
